// src/components/PhotoAnnotatorOptions.jsx
// import React from "react";

/**
 * Options panel: color, line width, emoji.
 *
 * Props:
 *  - show: boolean
 *  - color: string
 *  - lineWidth: number
 *  - emojis: string[]
 *  - selectedEmoji: string
 *  - onColorChange: (color: string) => void
 *  - onLineWidthChange: (n: number) => void
 *  - onSelectedEmojiChange: (emoji: string) => void
 */
export function PhotoAnnotatorOptions({
  show,
  color,
  lineWidth,
  //   emojis,
  //   selectedEmoji,
  onColorChange,
  onLineWidthChange,
  //   onSelectedEmojiChange,
}) {
  if (!show) return null;

  return (
    <div className="photo-annotator-options-row">
      <label className="photo-annotator-option-label">
        Color:
        <input
          type="color"
          value={color}
          onChange={(e) => onColorChange(e.target.value)}
          style={{ marginLeft: 8 }}
        />
      </label>

      <label className="photo-annotator-option-label">
        Size:
        <input
          type="range"
          min="1"
          max="30"
          value={lineWidth}
          onChange={(e) => onLineWidthChange(Number(e.target.value))}
          style={{ marginLeft: 8 }}
        />
        <span style={{ marginLeft: 8 }}>{lineWidth}px</span>
      </label>

      {/* <label className="photo-annotator-option-label">
        Emoji:
        <select
          value={selectedEmoji}
          onChange={(e) => onSelectedEmojiChange(e.target.value)}
          style={{ marginLeft: 8 }}
        >
          {emojis.map((emoji) => (
            <option key={emoji} value={emoji}>
              {emoji}
            </option>
          ))}
        </select>
      </label> */}
    </div>
  );
}
